var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1820px",
    height: "1820px",
    viewBox: "0 0 1820 1820",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#8898AA",
    strokeWidth: 100,
    cx: 910,
    cy: 910,
    r: 860
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(493.000000, 435.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.143889,0 L760.230222,285 L760.230222,308.75 L665.201444,403.75 L665.201444,332.5 L427.6295,332.5 L427.6295,95 L95.0287777,95 L95.0287777,855 L479.329321,855.003515 C509.510223,897.308356 551.526119,930.587861 600.54274,950.007759 L95.0287777,950 C42.76295,950 0,907.25 0,855 L0,95 C0,42.75 42.76295,0 95.0287777,0 L475.143889,0 Z M285.086333,570 L256.5777,698.25 L356.357916,617.5 L427.6295,617.5 L433.982279,645.459883 C430.712698,662.302689 429,679.701334 429,697.5 C429,731.205245 435.141875,763.475979 446.367486,793.254064 L403.872305,793.25 L375.363672,684 L237.571944,807.5 L166.300361,807.5 L213.81475,570 L285.086333,570 Z",
    id: "Combined-Shape",
    fill: "#8898AA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#8898AA",
    strokeWidth: 55,
    cx: 700.5,
    cy: 697.5,
    r: 225
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8898AA",
    fillRule: "nonzero",
    points: "811.489011 626.883242 771.116758 586.510989 700.5 657.127747 629.883242 586.510989 589.510989 626.883242 660.127747 697.5 589.510989 768.116758 629.883242 808.489011 700.5 737.872253 771.116758 808.489011 811.489011 768.116758 740.872253 697.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.58d45fe0fade8bebb85975f84b71b35d.svg";
export { ForwardRef as ReactComponent };